export default {"src":"/_next/static/media/Alejandro-Cartagena3.c7530289.JPG","height":548,"width":364};